/* unplugin-vue-components disabled */import script from "./InvoicingDeliveryView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicingDeliveryView.vue?vue&type=script&setup=true&lang=js"

import "./InvoicingDeliveryView.vue?vue&type=style&index=0&id=50394d88&lang=scss"

const __exports__ = script;

export default __exports__